import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'SUB_UNIT_LOGS_';

export default getActionsByDocument(DOCUMENT);
